/*eslint-disable */

import appFooter from '@/components/public/common/footer/';
import {
  bus
} from '@/main';
import variation_random_img1 from '@/assets/images/random_img/oddnary-variation-5.jpg';
import variation_random_img2 from '@/assets/images/random_img/oddnary-variation-7.jpg';
import variation_random_img3 from '@/assets/images/random_img/oddnary-variation-1.jpg';
import variation_random_img4 from '@/assets/images/random_img/oddnary-variation-4.jpg';
import variation_random_img5 from '@/assets/images/random_img/oddnary-variation-2.jpg';
import variation_random_img6 from '@/assets/images/random_img/oddnary-variation-6.jpg';
import welcome from '@/components/welcome-popup/index';

var $ = window.jQuery = require('jquery');

// Multi Color Bg Img Of Section

export default {
  name: 'contact-us',
  components: {
    'app-footer': appFooter,
    'welcome-popup': welcome
  },
  props: [],
  data () {
    return {
      imageIndex:''
    }
  },
  computed: {

  },
  mounted () {
    this.randomImgLoaded()
    bus.$emit('showHomeMenuBtn', true);
    $(document).ready(function(){
      var target = $('#us');
      $('html, body').animate({
          scrollTop: target.offset().top
      }, 1);
    })
    if (process.env.NODE_ENV == 'production') {
      this.$scriptLoader.load("https://www.googletagmanager.com/gtag/js?id=UA-152519411-1")
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-152519411-1');
    }
  },
  methods: {
    randomImgLoaded() {
      $('.app-loader').show()
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6"]
      var variation_images = [variation_random_img1, variation_random_img2, variation_random_img3, variation_random_img4, variation_random_img5, variation_random_img6]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      this.imageIndex = x
      var element = document.getElementsByClassName('random_bgimg');
      if (x < images.length) {
        $('.navbar_list_wrp').addClass('act_contest_clr_of_holders' + x);
        element[0].style["background-image"] = "url(" + variation_images[x] + ")"
        setTimeout(() => {
          this.preloader = false;
          $('.app-loader').hide()
        }, 1500);
      }
    },
  },
  beforeCreate: function() {
    $('body').addClass('about_us_wrp');
  },
  beforeRouteLeave: function(to, from, next) {
    $('.navbar_list_wrp').removeClass('act_contest_clr_of_holders' + this.imageIndex);
    $('body').removeClass('about_us_wrp');
    next();
  }
}
